<template>
  <v-app>
    <v-container
      id="testing-form"
      fluid
      tag="section"
    >
      <v-row justify="center">
        <v-col
          cols="12"
          md="8"
        >
          <base-material-card
            icon="mdi-test-tube-empty"
          >
            <template #after-heading>
              <div class="font-weight-light card-title mt-2">
                {{ title }}
              </div>
            </template>
            <div
              class="mt-5 mb-5"
              v-html="notice"
            />
            <div
              v-for="question in testQuestions"
              :key="question.id"
            >
              {{ question.question }}
              <div
                v-if="question.isYesNo"
                class="ml-5"
              >
                <v-checkbox
                  v-model="yesNoAnswers[question.id]"
                  label="Yes"
                />
                <v-textarea
                  v-if="yesNoAnswers[question.id]"
                  v-model="answers[question.id]"
                  class="purple-input"
                  label="Answer"
                  counter="200"
                  :rules="[rules.textLimit]"
                  @input="validateForm"
                />
              </div>
              <div
                v-else
                class="ml-5"
              >
                <v-textarea
                  v-model="answers[question.id]"
                  class="purple-input"
                  label="Answer"
                  counter="200"
                  :rules="[rules.textLimit]"
                  @input="validateForm"
                />
              </div>
            </div>
            <v-btn
              color="green darken-1"
              :disabled="isSubmitButtonDisabled || isSubmitted"
              @click="submitTest"
            >
              Submit
            </v-btn>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="showDialog"
          persistent
          max-width="500"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ dialogMessage }}
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="showDialog = false; dialogMessage = ''"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-app>
</template>

<script>
  import { fetchTestResults, writeTestResults } from '@/firebase'
  export default {
    data: () => ({
      testId: '',
      userId: '',
      user: '',
      title: 'Loading Test...',
      notice: '',
      testQuestions: [],
      yesNoAnswers: [],
      answers: [],
      isSubmitButtonDisabled: true,
      isSubmitted: false,
      showDialog: false,
      dialogMessage: '',
      rules: {
        textLimit: v => (v || '').length <= 200 || 'Answers must be 200 characters or less',
      },
    }),
    mounted () {
      this.testId = this.$route.params.testId
      this.userId = this.$route.params.userId
      this.loadTest()
    },
    methods: {
      loadTest () {
        fetchTestResults(this.testId)
          .then(results => {
            this.title = results.title
            this.notice = results.notice
            this.user = results.testers[this.userId]?.tester

            if (!this.user) {
              this.dialogMessage = 'You are not registered to do this test'
              this.showDialog = true
              this.isSubmitted = true
            } else if (results.testers[this.userId].answers === undefined || results.testers[this.userId].answers.length === 0) {
              this.testQuestions = results.questionSet
            } else {
              this.dialogMessage = 'You\'ve already answered this test. Thank you!'
              this.showDialog = true
              this.isSubmitted = true
            }
            this.validateForm()
          })
      },
      validateForm () {
        let valid = true
        this.testQuestions.forEach((testQuestion, index) => {
          if (testQuestion.isYesNo === false) {
            if (this.answers[index] === undefined || this.answers[index] === '' || this.answers[index] > 200) {
              valid = false
            }
          }
        })
        this.isSubmitButtonDisabled = !valid
      },
      submitTest () {
        const finalAnswers = this.answers.slice()
        let valid = true

        this.testQuestions.forEach((testQuestion, index) => {
          if (testQuestion.isYesNo === true) {
            if (this.yesNoAnswers[index] === true && (finalAnswers[index] === '' || finalAnswers[index] === undefined)) {
              finalAnswers[index] = 'yes'
            } else if (this.yesNoAnswers[index] === undefined || this.yesNoAnswers[index] === false) {
              finalAnswers[index] = 'no'
            }
          } else {
            if (finalAnswers[index] === '' || finalAnswers[index] === undefined) {
              valid = false
              this.dialogMessage = 'Please answer all the questions!'
            }
          }
          if (finalAnswers[index] > 200) {
            valid = false
            this.dialogMessage = 'All answers must be 200 characters or less'
          }
        })

        if (valid) {
          writeTestResults(this.user, this.testId, finalAnswers)
          this.dialogMessage = 'Eingaben gespeichert'
          this.showDialog = true
          this.isSubmitted = true
        } else {
          this.showDialog = true
        }
      },
    },
  }

</script>
